import axios from "axios";

export const makeRequest = axios.create({
  baseURL: "https://calendario.centrospaziovitale.it:3002/server/",
  //baseURL: "http://localhost:3001/server/",
  withCredentials: true,
});